import React, { useState } from 'react';
import {
  CustomModal,
  Loader,
  ALL_MODULES,
  ALL_SHARD_MODULES,
  getParsedCrudData,
  COMMON_CONSTANTS
} from '@nile/components';
import CustomFieldSheet from '@nile/banyan/src/Components/Sheets/CustomFieldSheet';
import styled from 'styled-components';
import { AccountClient } from '@nile/graphql';
import { GET_FIELD } from '@nile/banyan/src/Graphql/Mutations/ticket';
import { useQuery } from '@apollo/client';
import { isEmpty, pick } from 'lodash';
import { useFlags } from 'launchdarkly-react-client-sdk';

const ModalWrapper = styled.div`
  width: 70vw;
  height: 90vh;
  background: #fff;
  border-radius: 10px;
`;

const CustomFieldModal = (props) => {
  const {
    modalActive,
    setModalActive,
    data,
    module,
    disableEdit,
    updateField,
    showWarning
  } = props;
  const flags = useFlags();

  const closeModal = () => {
    setModalActive(!modalActive);
  };

  const { data: customFieldData, loading, error } = useQuery(GET_FIELD, {
    client: AccountClient,
    fetchPolicy: COMMON_CONSTANTS.CACHE_POLICIES.NETWORK_ONLY,
    variables: {
      input: {
        entity: module || ALL_SHARD_MODULES.ticket,
        id: data?.id
        // columnName: columnName
      }
    }
  });

  const fieldoptions =
    customFieldData?.getField?.options ||
    customFieldData?.getField?.fieldOptions;

  const responseCallBack = (res) => {
    if (res?.updateField || res?.updateFieldV2) {
      setModalActive(false);
    }
  };

  const updateCustomField = (updatedData, cb) => {
    const variables = updatedData?.input;
    const updatedFieldOptions = variables?.fieldOptions;
    const base =
      customFieldData?.getField?.options ||
      customFieldData?.getField?.fieldOptions;

    let fieldOptionsInput = {};
    if (base) {
      const result = getParsedCrudData(base, updatedFieldOptions);

      const { addedItems, deletedItems, updatedItems } = result;

      if (addedItems.length > 0) {
        fieldOptionsInput = {
          ...fieldOptionsInput,
          added: addedItems,
          addOptions: addedItems
        };
      }

      if (deletedItems.length > 0) {
        fieldOptionsInput = {
          ...fieldOptionsInput,
          deleted: deletedItems,
          deleteOptions: deletedItems
        };
      }

      if (updatedItems.length > 0) {
        fieldOptionsInput = {
          ...fieldOptionsInput,
          updated: updatedItems,
          updateOptions: updatedItems
        };
      }
    }

    const {
      id,
      label,
      mandatoryOnCreate,
      mandatoryOnClosure,
      showToClients,
      showToClient,
      description,
      fieldCategory
    } = variables;

    let vars = {
      id,
      mandatoryOnCreate,
      mandatoryOnClosure,
      showToClients,
      description,
      label
    };

    if (fieldCategory !== 'DEFAULT') {
      vars = { ...vars, showToClient, showToClients };
    }

    const fieldOptionsIp = isEmpty(fieldOptionsInput)
      ? undefined
      : JSON.stringify(fieldOptionsInput);

    vars = flags?.dependentField
      ? {
          ...vars,
          addOptions: fieldOptionsInput?.addOptions?.map((el) =>
            pick(el, ['value', 'description', 'order', 'parentOption'])
          ),
          updateOptions: fieldOptionsInput?.updateOptions?.map((el) =>
            pick(el, ['value', 'description', 'order', 'id'])
          ),
          deleteOptions: fieldOptionsInput?.deleteOptions?.map((el) =>
            pick(el, ['id'])
          )
        }
      : { ...vars, fieldOptionsInput: fieldOptionsIp };

    updateField(vars, (dta) => {
      if (cb) cb();
      responseCallBack(dta);
    });
  };

  const actions = {
    primaryAction: updateCustomField,
    back: closeModal
  };

  if (loading) {
    return (
      <>
        <CustomModal
          open={modalActive}
          onClose={() => setModalActive(!modalActive)}
        >
          <ModalWrapper className="modal-wrapper">
            <Loader />
          </ModalWrapper>
        </CustomModal>
      </>
    );
  }

  return (
    <>
      <CustomModal
        open={modalActive}
        onClose={() => setModalActive(!modalActive)}
      >
        <ModalWrapper className="modal-wrapper">
          <CustomFieldSheet
            hidePreview={props.hidePreview}
            customField={{
              ...customFieldData?.getField,
              options: fieldoptions
                ? fieldoptions?.map((el) => {
                    return {
                      value: el?.value,
                      id: el?.id,
                      parentOption: el?.parentOption
                    };
                  })
                : null
            }}
            actions={actions}
            module={module || 'TICKET'}
            constraints={props?.constraints || {}}
            page={props?.page || null}
            disableEdit={disableEdit}
            showWarning={showWarning}
            hideMandatoryOnClosure={module !== 'TICKET'}
            hideMandatoryOnCreation={module !== 'TICKET'}
          />
        </ModalWrapper>
      </CustomModal>
    </>
  );
};

export default CustomFieldModal;
